'use client';

import * as React from 'react';

import { ThemeProvider as NextThemesProvider, type ThemeProviderProps } from 'next-themes';

function ThemeProvider({ children, ...props }: ThemeProviderProps) {
	return (
		<React.StrictMode>
			<NextThemesProvider {...props}>{children}</NextThemesProvider>
		</React.StrictMode>
	);
}

export default ThemeProvider;
